import React, { useId } from 'react';
/**
 * Mosque dome silhouette mask, traced from the supplied reference SVG: a wide,
 * full-bodied bulbous dome with a small finial, necking slightly into NEAR-
 * VERTICAL side walls that run straight down to a flat bottom edge (no plinth).
 * Intentionally "fat" with almost-straight sides. Drawn in a 200×148 viewBox.
 */
const ARCH_PATH = 'M 100 6 C 120 12 178 24 180 64 C 180 76 178 84 176 92 L 176 144 L 24 144 L 24 92 C 22 84 20 76 20 64 C 22 24 80 12 100 6 Z';
interface MosqueArchMaskProps {
  src: string;
  alt: string;
  className?: string;
  /** "slice" fills the frame (default); "meet" shows the whole image. */
  fit?: 'slice' | 'meet';
}
export function MosqueArchMask({
  src,
  alt,
  className = '',
  fit = 'slice'
}: MosqueArchMaskProps) {
  const uid = useId().replace(/:/g, '');
  const clipId = `arch-clip-${uid}`;
  const shadowId = `arch-shadow-${uid}`;
  return <svg viewBox="0 0 200 148" className={`w-full h-full overflow-visible ${className}`} role="img" aria-label={alt} data-id="element-775" data-mp="1tqnz8brhi88t">
      <defs data-id="element-776" data-mp="mxz7vqibfu1f">
        <clipPath id={clipId} data-id="element-777" data-mp="n0lhdvorojma">
          <path d={ARCH_PATH} data-id="element-778" data-mp="hz5wq4qi4f4f" />
        </clipPath>
        <filter id={shadowId} x="-20%" y="-20%" width="140%" height="140%" data-id="element-779" data-mp="i0fuestfzlaj">
          <feDropShadow dx="0" dy="2" stdDeviation="3" floodColor="#0F5132" floodOpacity="0.25" data-id="element-780" data-mp="d7mqg75ssgzi" />
        </filter>
      </defs>
      <path d={ARCH_PATH} fill="#E8EFE9" filter={`url(#${shadowId})`} data-id="element-781" data-mp="492f5r2kh9lb" />
      <image href={src} x="0" y="0" width="200" height="148" preserveAspectRatio={`xMidYMid ${fit}`} clipPath={`url(#${clipId})`} data-id="element-782" data-mp="3ve12u1of4ivs" />
      <path d={ARCH_PATH} fill="none" stroke="#C9A864" strokeWidth="1.6" strokeLinejoin="round" data-id="element-783" data-mp="3me5qhtj4mhu6" />
    </svg>;
}